// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3zgsl","form":"styles_form__138KV"};